export default __webpack_public_path__ + "static/media/yahoo_grey.3544ecfa.svg";